const BEIJING_OFFSET_MS = 8 * 60 * 60 * 1000;

function pad(value) {
  return String(value).padStart(2, "0");
}

function dateParts(value) {
  if (value === null || value === undefined || value === "") return null;
  const text = String(value).trim();
  if (!text) return null;

  const dateOnly = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnly) {
    return { year: dateOnly[1], month: dateOnly[2], day: dateOnly[3], hour: "00", minute: "00", second: "00" };
  }

  const hasTimezone = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})$/i.test(text);
  if (hasTimezone) {
    const timestamp = Date.parse(text);
    if (Number.isFinite(timestamp)) {
      const date = new Date(timestamp + BEIJING_OFFSET_MS);
      return {
        year: String(date.getUTCFullYear()),
        month: pad(date.getUTCMonth() + 1),
        day: pad(date.getUTCDate()),
        hour: pad(date.getUTCHours()),
        minute: pad(date.getUTCMinutes()),
        second: pad(date.getUTCSeconds())
      };
    }
  }

  const plainDateTime = text.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/);
  if (plainDateTime) {
    return {
      year: plainDateTime[1],
      month: plainDateTime[2],
      day: plainDateTime[3],
      hour: plainDateTime[4],
      minute: plainDateTime[5],
      second: plainDateTime[6] || "00"
    };
  }

  return null;
}

export function formatDateTime(value, fallback = "-") {
  const parts = dateParts(value);
  if (!parts) return fallback;
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
}

export function formatDate(value, fallback = "-") {
  const parts = dateParts(value);
  if (!parts) return fallback;
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function formatShortDateTime(value, fallback = "-") {
  const parts = dateParts(value);
  if (!parts) return fallback;
  return `${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
}
